// import Connection from './connection'

let knownErrors = {
   'unknown': async (error) => {
      $notify('error', 'Unknown Error', 'An Error has Occured')
   },
   '5011': async (error) => {
      $notify('error', 'User Authentication Failed', 'User Authantication Failed')
      main_vue.$store.getters.router.push({name: 'LogIn'})
   },
   '422': async (error) => {
      let errors = []

      for (const error_field of error.error_fields) {
         for (const [key,val] of Object.entries(error_field)) {
            errors.push({field: key, message: val.message})
         }
      }

      Event.$emit('form:validation_error',{errors})
      $notify('warning', 'Form Validation', 'Input form validation failed. Correct the highlighted inputs before proceeding.')
   }
}

export default class ErrorHandler {
   constructor(router) {
      this.router = router;
   }

   async handleError(err) {
      if (err && err.error && err.error.code) {
         err = err.error
         let code = err.code.toString()
         let errAction = knownErrors[code]

         if (errAction) {
            await errAction(err)
         } else {
            if(err.msg){
               $notify('error', `Error - ${err.code}`, err.msg)
            }else{
               await knownErrors['unknown'](err)
            }
         }
      } else {
         if (err.message) {
            if(err.message === 'Failed to fetch'){
               // console.log(err)
               // $notify('connection', 'Connection Error', 'Failed to connect to the gateway service',20)
            }else{
               $notify('error', 'Error', err.message)
            }
         } else {
            $notify('error', 'Error', 'An Error Occured.')
         }
      }
   }
}